import { Routes } from '@angular/router'

import { DefaultApplicationPermissionsGuard } from '@flowx/designer/shared/guards/application-permissions.guards'
import { DefaultPermissionsGuard } from '@flowx/designer/shared/guards/workspaces-permissions.guards'
import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

import { RuntimeActiveInstancesRoutes } from './runtime-active-instances-routes'
import { RuntimeUiFlowSessionsRoutes } from './runtime-ui-flow-sessions-routes'

import { ExceptionDetailsPageComponent } from '../process/pages/exception-details-page/exception-details-page.component'
import { ExceptionsPageComponent } from '../process/pages/exceptions/exceptions-page.component'
import { RuntimeProcessInstanceRoutes } from '../process/runtime-process-instance-routes'
import { RuntimeReusableUiTemplateInstanceRoutes } from '../reusable-ui-template/runtime-reusable-ui-template-instance-routes'
import { UiFlowInstanceRoutes } from '../ui-flow/ui-flow-instance-routes'

export const ApplicationRuntimeRoutes: Routes = [
  {
    path: '',
    redirectTo: 'builds-list',
    pathMatch: 'full',
  },
  {
    path: 'active-policy',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    canActivate: [DefaultPermissionsGuard('wks_active_policy_read')],
    loadComponent: () =>
      import(
        '@flowx/designer/modules/projects/components/active-policy/active-policy.component'
      ).then(({ FlxActivePolicyComponent }) => FlxActivePolicyComponent),
  },
  {
    path: 'scheduled-processes',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    canActivate: [DefaultPermissionsGuard('wks_active_policy_read')],
    loadComponent: () =>
      import(
        '@flowx/designer/modules/projects/components/scheduled-processes/scheduled-processes.component'
      ).then(({ ScheduledProcessesComponent }) => ScheduledProcessesComponent),
  },
  {
    path: 'manage-triggers',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    canActivate: [DefaultPermissionsGuard('wks_active_policy_read')],
    loadComponent: () =>
      import(
        '@flowx/designer/modules/projects/components/manage-triggers/manage-triggers.component'
      ).then(({ ManageTriggersComponent }) => ManageTriggersComponent),
  },
  {
    path: 'overrides',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    canActivate: [DefaultPermissionsGuard('wks_config_param_overrides_read')],
    loadComponent: () =>
      import(
        '@flowx/designer/modules/projects/components/configuration-parameters-overrides/list/configuration-parameters-overrides-list.component'
      ).then(
        ({ FlxConfigurationParametersOverridesListComponent }) =>
          FlxConfigurationParametersOverridesListComponent
      ),
  },
  {
    path: 'builds-list',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    canActivate: [DefaultPermissionsGuard('wks_builds_read')],
    loadComponent: () =>
      import('@flowx/designer/modules/projects/components/builds-list/builds-list.component').then(
        ({ FlxBuildsListComponent }) => FlxBuildsListComponent
      ),
    children: [
      {
        path: 'workflow-instances',
        loadChildren: () =>
          import(
            '@flowx/designer/modules/integration-designer/workflow-integration/workflow-instances-routes'
          ).then((m) => m.workflowInstancesRoutes),
        outlet: 'workflowInstances',
      },
    ],
  },
  {
    path: 'exceptions',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    component: ExceptionsPageComponent,
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_read')],
  },
  {
    path: 'exceptions/:id',
    component: ExceptionDetailsPageComponent,
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_read')],
  },
  {
    path: 'failed-triggers',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_read')],
    loadComponent: () =>
      import(
        '@flowx/designer/modules/projects/components/failed-triggers/failed-triggers.component'
      ).then(({ FailedTriggersComponent }) => FailedTriggersComponent),
  },
  {
    path: 'failed-triggers/:id',
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_read')],
    loadComponent: () =>
      import(
        '@flowx/designer/modules/projects/components/failed-triggers/failed-trigger-details/failed-trigger-details.component'
      ).then(({ FailedTriggerDetailsComponent }) => FailedTriggerDetailsComponent),
  },

  {
    path: 'task-manager',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    canActivate: [DefaultPermissionsGuard('wks_tasks_read')],
    loadComponent: () =>
      import(
        '@flowx/designer/modules/projects/components/runtime-task-manager/runtime-task-manager.component'
      ).then(({ FlxRuntimeTaskManagerComponent }) => FlxRuntimeTaskManagerComponent),
  },
  {
    path: 'ui-flows',
    children: RuntimeUiFlowSessionsRoutes,
  },
  {
    path: ':appVersionId/processes',
    children: RuntimeProcessInstanceRoutes,
  },
  {
    path: ':appVersionId/reusable-resources',
    children: RuntimeReusableUiTemplateInstanceRoutes,
  },
  {
    path: ':appVersionId/ui-flow',
    children: UiFlowInstanceRoutes,
  },
  {
    path: 'active-instances',
    children: RuntimeActiveInstancesRoutes,
  },
]
